import React from 'react';
import { Box } from '@mui/system';
import { makeStyles } from '@mui/styles';
import Banner from '../../atoms/Banner/Banner';
import Typography from '../../atoms/Typography/Typography';
import Plancard from '../../atoms/Plancard';

const useStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mapBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  oddeven: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },

  leftBox: {
    width: '50%',
    textAlign: 'right',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    paddingTop: '20px',
    paddingBottom: '60px',
    '&:nth-child(odd)': {
      backgroundColor: '#f4f6f9',
    },
    '@media only screen and (max-width: 768px)': {
      width: '100%',
    },
  },
  leftBox2: {
    width: '50%',
    textAlign: 'right',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    paddingTop: '20px',
    paddingBottom: '60px',
    '@media only screen and (max-width: 768px)': {
      width: '100%',
    },
  },
  textTitle: {
    position: 'absolute',
    fontFamily: 'Pretendard',
    textAlign: 'left !important',
    fontSize: '18px',
    fontWeight: 'bold',
    letterSpacing: '-0.18px',
    color: '#191919',
    maxWidth: '500px',
    width: '40vw',
    '@media only screen and (max-width: 768px)': {
      width: '80vw',
    },
  },
  semiTitle: {
    marginTop: '36px',
    fontFamily: 'Pretendard',
    fontSize: '16px',
    fontWeight: 'bold',
    letterSpacing: '-0.18px',
    color: '#191919',
    marginBottom: '7px',
    marginRight: '10%',
    marginLeft: '10%',
  },
  text1: {
    marginBottom: '17px',
    fontFamily: 'Pretendard',
    fontSize: '16px',
    lineHeight: 1.25,
    letterSpacing: '-0.16px',
    color: '#191919',
    marginRight: '10%',
    marginLeft: '10%',
    maxWidth: '50%',
  },
  text: {
    marginBottom: '17px',
    fontFamily: 'Pretendard',
    fontSize: '16px',
    lineHeight: 1.25,
    letterSpacing: '-0.16px',
    color: '#191919',
    marginRight: '10%',
    marginLeft: '10%',
    maxWidth: '50%',
  },
  rightBox: {
    width: '50%',
    paddingTop: '20px',
    paddingBottom: '60px',
    '@media only screen and (max-width: 768px)': {
      width: '100%',

      '&:nth-child(even)': {
        backgroundColor: '#f4f6f9',
      },
    },
  },
  rightBox2: {
    width: '50%',

    // paddingRight: '20vw',
    // paddingLeft: '60px',
    paddingTop: '20px',
    paddingBottom: '60px',

    '&:nth-child(even)': {
      backgroundColor: '#f4f6f9',
    },
    '@media only screen and (max-width: 768px)': {
      // width: '72vw',
      width: '100%',

      '&:nth-child(even)': {
        backgroundColor: '#fff',
      },
    },
  },
  ////////////
  bottomTitleBox: {
    width: '100%',
    backgroundColor: 'black',
    textAlign: 'center',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bottomTitleText: {
    textDecoration: 'underline',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: 1.25,
    color: '#f4f4f4',
    '@media only screen and (max-width: 768px)': {
      fontSize: '16px',
    },
  },
  planCardBox: {
    width: '85%',
    marginTop: '88px',
    display: 'flex',
    justifyContent: 'space-between',
    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  planCard: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
});

export default function TrackIntroducePage() {
  const classes = useStyles();

  const bannerData = {
    imgSrc: '/images/image/message title@2x.png',
    imgSrcM: '/images/image/messagem title@2x.png',
    title: 'Track Introduce',
    text1: 'The curriculum of the Korea Information Technology Research Institute',
    text2: 'consists of four tracks: vulnerability analysis, digital forensics, security consulting, and security product development.',
  };

  const cardData = [
    {
      title: 'Vulnerability Analysis',
      concept1: '-Understanding what causes security vulnerabilities',
      concept2: '-Learning trends in information security technology to prevent accidents in advance,',
      contents1: '-reverse engineering technique',
      contents2: '-Understanding vulnerabilities',
      contents3: '-Network and operating system principles',
      contents4: '',
    },
    {
      title: 'Digital forensics',
      concept1: '-Understanding Digital Forensics Fundamentals Concepts',
      concept2: '-Learn how to use them through case studie sand practice case studies',
      contents1: '-reverse engineering technique',
      contents2: '-Understanding vulnerabilities',
      contents3: '-Network and operating system principles',
      contents4: '',
    },
    {
      title: 'Security consulting',
      concept1: '-Learn about the latest information securit policies and management systems',
      concept2: '-Cultivation of basic consulting knowledge through understanding of consulting techniques and legal systems',
      contents1: '-Security Consulting Techniques',
      contents2: '-Security authentication system and laws/systems',
      contents3: '-Audit and Industrial Security',
      contents4: '-Security Market Trends',
    },
    {
      title: 'Security product development',
      concept1:
        '-Responding to cybersecurity threats by implementing software ofsecurity control functions to maintain confidentiality, integrity, and availability of information resources',
      concept2:
        '-For safe SW development, remove potential security vulnerabilities that may exist in source code, etc., and design and  mplement functions in consideration of security.',
      contents1: '-Development Security Methodology',
      contents2: '-software development security',
      contents3: '-Development Security Reinforcement Activities',
      contents4: '-Implementation of development security',
    },
  ];

  const planCardData = [
    {
      ImageSrc: '/images/icon/card/flaticon4.png',
      month: 'Major education',
      redtitle: '200 people',
      title: '',
      text: [
        {
          line: 'July~August',
        },
        {
          line: '-Professional learning and security basic subject learning',
        },
        {
          line: '-Security major learning projec and practice / practice,',
        },
        {
          line: '',
        },
        {
          line: '',
        },
      ],
    },
    {
      ImageSrc: '/images/icon/card/flaticon6.png',

      month: 'Team project training',
      redtitle: '200 people',
      title: '',
      text: [
        {
          line: 'September~December',
        },
        {
          line: '--Deep learning with top experts in each field',
        },
        {
          line: ' -Perform team projects by field of expertise',
        },
      ],
    },
    {
      ImageSrc: '/images/icon/card/flaticon10.png',

      month: 'Competition training',
      redtitle: '30 selected',
      title: '',

      text: [
        {
          line: 'January~February',
        },
        {
          line: '-Selection of 30 contestants through evaluation',
        },
        {
          line: '-Track Intensive Training,',
        },
        {
          line: '',
        },
        {
          line: '',
        },
      ],
    },
    {
      ImageSrc: '/images/icon/card/flaticon12.png',
      month: 'Certification',
      redtitle: 'Best 10, Grand Prix selection',
      title: '',
      text: [
        {
          line: 'March',
        },
        {
          line: ' -Top 10 Certifications by Assessment',
        },
        {
          line: '  -Grand Prix selection through evaluation',
        },
        {
          line: '  -Support for start-up and technology commercialization',
        },
        {
          line: '  -Support for continuous advancement into information security field',
        },
      ],
    },
  ];

  return (
    <Box className={classes.root}>
      <Banner bannerData={bannerData} />
      {cardData.map((card, i) => {
        return (
          <Box className={classes.mapBox} key={i}>
            {i % 2 === 0 ? (
              <Box className={classes.oddeven}>
                <Box className={classes.leftBox}>
                  <Typography className={classes.textTitle}>{card.title}</Typography>
                  <Typography className={classes.semiTitle}>Concept</Typography>
                  <Typography className={classes.text1}>{card.concept1}</Typography>
                  <Typography className={classes.text1}>{card.concept2}</Typography>
                </Box>

                <Box className={classes.rightBox}>
                  <Typography className={classes.semiTitle}>Learning contents</Typography>
                  <Typography className={classes.text}>{card.contents1}</Typography>
                  <Typography className={classes.text}>{card.contents2}</Typography>
                  <Typography className={classes.text}>{card.contents3}</Typography>
                  <Typography className={classes.text}>{card.contents4}</Typography>
                </Box>
              </Box>
            ) : (
              <Box className={classes.oddeven}>
                <Box className={classes.leftBox2}>
                  <Typography className={classes.textTitle}>{card.title}</Typography>
                  <Typography className={classes.semiTitle}>Concept</Typography>
                  <Typography className={classes.text1}>{card.concept1}</Typography>
                  <Typography className={classes.text1}>{card.concept2}</Typography>
                </Box>

                <Box className={classes.rightBox2}>
                  <Typography className={classes.semiTitle}>Learning contents</Typography>
                  <Typography className={classes.text}>{card.contents1}</Typography>
                  <Typography className={classes.text}>{card.contents2}</Typography>
                  <Typography className={classes.text}>{card.contents3}</Typography>
                  <Typography className={classes.text}>{card.contents4}</Typography>
                </Box>
              </Box>
            )}
          </Box>
        );
      })}
      <Box className={classes.bottomTitleBox}>
        <Typography className={classes.bottomTitleText}>Talent Development Roadmap</Typography>
      </Box>
      <Box className={classes.planCardBox}>
        {planCardData.map((data, i) => {
          return (
            <Box className={classes.planCard} key={i}>
              <Plancard data={data} />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
